export default "__VITE_ASSET__DJIc41u3__"